window['ThemeComponent_Quantity'] = () => {
  return {
    quantity: 12,
    dispatchInputChange() {
      this.$refs.quantityInput.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    },
    decreaseQuantity() {
      if (this.quantity >= 24) {
        this.quantity = this.quantity - 12;
      }
      this.dispatchInputChange();
      return liveRegion(this.quantity);
    },
    increaseQuantity() {
        this.quantity = this.quantity + 12;
      this.dispatchInputChange();
      return liveRegion(this.quantity);
    }
  };
};
